/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */

import { writable } from 'svelte/store';
import fetchFromStorefront from '../../utils/storefront.js';

export const activeCollectionTab = writable('');

export const collectionsStore = writable([]);

export const viewAllBgColour = writable('');

export const viewAllButton = writable('');

export const isLoading = writable(false);

function getCollectionData(handle, limit) {
  const query = `
      query t {
        collection(handle: "${handle}") {
          handle
          products(first: ${limit}) {
            edges {
              node {
                tags
                title
                featuredImage {
                  url
                }
                id
                handle
                availableForSale
                priceRange {
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                }
                options {
                  name
                  values
                }
              }
            }

          }
        }
      }
    `;

  return fetchFromStorefront(query);
}

export function setActiveTab(title) {
  activeCollectionTab.update(tab => (tab = title));
}

export async function getCollectionFromStorefront(handle, limit = 9) {
  isLoading.update(loading => (loading = true));
  const response = await getCollectionData(handle, limit);
  const { products } = response.data.collection;

  isLoading.update(loading => (loading = false));

  return products.edges;
}
